@if (selection()?.value === "dueOn") {
    <wk-fm-due-on [model]="dueOnModel()" (dateChange)="dueOnChange.emit($any($event))" />
}
@if (selection()?.value === "dateRange") {
    <div class="date-range">
        <date-picker-pds3
            [label]="'FiltersSidebar.Labels.From' | translate"
            [date]="fromModel().date"
            [inputPlaceholder]="currentLanguage === 'fr-CA' ? 'AAAA-MM-JJ' : 'YYYY-MM-DD'"
            [formatDateFn]="WkDateFormat.formatDateFn"
            [parseDateFn]="WkDateFormat.parseDateFn"
            [validateDateStringFn]="WkDateFormat.validateDateStringFn"
            mask="9999-99-99"
            flowClass="date-picker-input"
            [i18n]="WkDateFormat.getDatePickerI18n(currentLanguage)"
            [disableFn]="disabledFromDates"
            (dateChange)="fromChange.emit($any($event))"
            inputTitle=""
        />
        <date-picker-pds3
            [label]="'FiltersSidebar.Labels.To' | translate"
            [date]="toModel().date"
            [inputPlaceholder]="currentLanguage === 'fr-CA' ? 'AAAA-MM-JJ' : 'YYYY-MM-DD'"
            [formatDateFn]="WkDateFormat.formatDateFn"
            [parseDateFn]="WkDateFormat.parseDateFn"
            [validateDateStringFn]="WkDateFormat.validateDateStringFn"
            mask="9999-99-99"
            flowClass="date-picker-input"
            [i18n]="WkDateFormat.getDatePickerI18n(currentLanguage)"
            [disableFn]="disabledToDates"
            (dateChange)="toChange.emit($any($event))"
            inputTitle=""
        />
    </div>
}
